// HearingNotice.js
import React from "react";

export default function HearingNotice({ formData, objectionData }) {
  if (!formData || !objectionData) return <p>लोड होत आहे...</p>;

  const formatTime = (timeStr) => {
    if (!timeStr) return "____";
    const [hour, minute] = timeStr.split(":");
    const h = parseInt(hour);
    const ampm = h >= 12 ? "सायं." : "सकाळी";
    const hour12 = h % 12 === 0 ? 12 : h % 12;
    return `${hour12}:${minute} ${ampm}`;
  };

  const getFullName = () => {
    return objectionData?.name || "________________";
  };

  const getAddress = () => {
    return objectionData?.address || "________________";
  };

  const getVillage = () => {
    return objectionData?.village || "_____________";
  };

  const getTaluka = () => {
    return objectionData?.taluka || "__________";
  };

  const getDistrict = () => {
    return objectionData?.district || "__________";
  };

  const formattedDate = formData.hearingDate
    ? new Date(formData.hearingDate).toLocaleDateString("en-IN")
    : "________________";

  return (
    <div id="printable-notice" className="font-serif text-[15px] text-black p-6 whitespace-pre-line leading-[1.8]">
      <div className="text-center font-bold text-lg mb-2">नमुना क्र. ५</div>
      <p className="mb-4 text-base font-semibold tracking-wide font-sans">
        भूसंपादन प्रकरण क्रमांक: {objectionData?.case_no || `LAQ${new Date().getFullYear()}${formData.objection_id}`}
      </p>

      <p>प्रति,</p>
      <p className="ml-6 font-medium">{getFullName()}</p>

      <p className="mt-4">
        खालील नमूद जागेच्या भूसंपादनाच्या अनुषंगाने आपण आपली हजेरी स्वतः किंवा आपला प्रतिनिधी यांच्यामार्फत
        खाली नमूद ठिकाणी द्यावी. <span className="font-sans underline italic font-bold">{formData.HearingLocation}</span> येथे दिनांक{" "}
        <span className="font-sans underline italic font-bold">{formattedDate}</span> रोजी{" "}
        <span className="font-sans underline italic font-bold">
          {formData.HearingTime ? formatTime(formData.HearingTime) : "____"}
        </span> वाजता आपली हजेरी लावून आपणास खालील नमूद जमिनीमध्ये असलेल्या हक्कासंदर्भात
        आपली भूमिका मांडावी व भूसंपादनासाठी ती जागा शासनाने ताब्यात घेतल्यामुळे आपणास नुकसानभरपाई किती मिळावी
        या संदर्भातील आपली मागणी सादर करावी. तसेच जमिनीचे मोजमाप चुकीचे असल्यास त्यावरील हरकती नमूद कराव्यात.
      </p>

      <div className="mt-6">
        {objectionData?.survey_no && (
          <p className="mb-4 text-base font tracking-wide font-sans"><strong>सर्व्हे  / प्लॉट क्रमांक:</strong> {objectionData.survey_no}</p>
        )}
        <p><strong>धारकाचे नाव:</strong> {getFullName()}</p>
        <p><strong>जमिनीचा उपयोगाचा हेतू:</strong> मध्यम प्रकल्प</p>
      </div>

      <div className="mt-10 text-right">
        <p>विशेष भूसंपादन अधिकारी</p>
        <p>ब आणि क विभाग, बुलडाणा</p>
      </div>
    </div>
  );
}
